module.exports = __webpack_public_path__ + "a16e3377c16886322e648008e3474dd0.svg";